import {
  AI_ONBOARDING_INITIAL_SNAPSHOT,
  IAiOnboardingDraft,
  IAiOnboardingSnapshot,
} from '../models/AiOnboardingModels';

import {
  LicenseVerificationRecord,
  OnboardingRepository,
  OnboardingSnapshot,
} from './types';

interface ILocalOnboardingRepository {
  onSnapshotChange?: (snapshot: OnboardingSnapshot) => void;
}

const doNothing = () =>
  null;

export class LocalOnboardingRepository implements OnboardingRepository {
  private snapshot: OnboardingSnapshot;

  private readonly onSnapshotChange: (
    snapshot: OnboardingSnapshot,
  ) => void;

  constructor(
    {
      onSnapshotChange = doNothing,
    }: ILocalOnboardingRepository,
    initialSnapshot: OnboardingSnapshot = AI_ONBOARDING_INITIAL_SNAPSHOT,
  ) {
    this.snapshot = { ...initialSnapshot };
    this.onSnapshotChange = onSnapshotChange;
  }

  reset() {
    this.updateSnapshot({ ...AI_ONBOARDING_INITIAL_SNAPSHOT });
  }

  saveLicenseVerification(input: LicenseVerificationRecord) {
    const {
      licenseNumber,
      licenseVerified,
      nameVerified,
    } = input;

    this.updateSnapshot({
      ...this.snapshot,
      licenseVerified,
      nameVerified,
      onboardingDetails: {
        ...this.snapshot.onboardingDetails,
        licenseNumber,
      },
    });

    return Promise.resolve();
  }

  saveOnboardingDetails(input: IAiOnboardingDraft) {
    this.updateSnapshot({
      ...this.snapshot,
      onboardingDetails: {
        ...this.snapshot.onboardingDetails,
        ...input,
      },
    });

    return Promise.resolve();
  }

  async getSnapshot() {
    return this.snapshot;
  }

  private updateSnapshot(snapshot: IAiOnboardingSnapshot) {
    this.snapshot = snapshot;
    this.onSnapshotChange(this.snapshot);
  }
}
